import React, { useState } from 'react'

const CookiesConfig = () => {
  const [showCustomPreferences, setShowCustomPreferences] = useState(false)
  const [cookiePreferences, setCookiePreferences] = useState({
    analytics: false,
    functional: false,
  })

  const handleToggleCustomPreferences = () => {
    setShowCustomPreferences(!showCustomPreferences)
  }

  const handleCheckboxChange = (e) => {
    setCookiePreferences({
      ...cookiePreferences,
      [e.target.name]: e.target.checked,
    })
  }

  const handleAcceptAll = () => {
    setCookiePreferences({
      analytics: true,
      functional: true,
    })
    // Save to localStorage
    localStorage.setItem(
      'cookiePreferences',
      JSON.stringify({
        essential: true,
        analytics: true,
        functional: true,
        timestamp: new Date().toISOString(),
      })
    )
  }

  const handleEssentialOnly = () => {
    setCookiePreferences({
      analytics: false,
      functional: false,
    })
    // Save to localStorage
    localStorage.setItem(
      'cookiePreferences',
      JSON.stringify({
        essential: true,
        analytics: false,
        functional: false,
        timestamp: new Date().toISOString(),
      })
    )
  }

  const handleSavePreferences = () => {
    // Save to localStorage
    localStorage.setItem(
      'cookiePreferences',
      JSON.stringify({
        essential: true,
        analytics: cookiePreferences.analytics,
        functional: cookiePreferences.functional,
        timestamp: new Date().toISOString(),
      })
    )
  }

  return (
    <div className='min-h-screen flex flex-col bg-background'>
      <main className='flex-grow container mx-auto px-4 py-8'>
        <h1 className='text-3xl font-bold text-text-primary mb-6'>
          Configuración de Cookies
        </h1>

        <div className='bg-card p-6 rounded-lg shadow-sm'>
          <p className='text-text-secondary mb-4'>
            Última actualización: 23 de marzo de 2025
          </p>

          <h2 className='text-xl font-semibold text-text-primary mb-4'>
            ¿Qué son las cookies?
          </h2>
          <p className='text-text-secondary mb-4'>
            Las cookies son pequeños archivos de texto que los sitios web
            colocan en tu dispositivo para almacenar información. Estas cookies
            permiten que el sitio web recuerde tus acciones y preferencias
            durante un período de tiempo, para que no tengas que volver a
            introducir cierta información cada vez que visites el sitio o
            navegues de una página a otra.
          </p>

          <h2 className='text-xl font-semibold text-text-primary mb-4 mt-6'>
            Tipos de cookies que utilizamos
          </h2>

          <div className='mb-6'>
            <h3 className='text-lg font-medium text-text-primary mb-2'>
              Cookies Esenciales (Necesarias)
            </h3>
            <p className='text-text-secondary mb-2'>
              Estas cookies son imprescindibles para el funcionamiento básico de
              nuestro sitio web. Te permiten navegar por nuestro sitio y
              utilizar sus funciones, como acceder a áreas seguras. Sin estas
              cookies, los servicios que has solicitado no pueden ser
              proporcionados.
            </p>
            <p className='text-text-secondary mb-2'>
              Ejemplos de cookies esenciales:
            </p>
            <ul className='list-disc pl-6 text-text-secondary mb-4'>
              <li className='mb-1'>
                Cookies de sesión para gestionar tu visita actual
              </li>
              <li className='mb-1'>
                Cookies que recuerdan tus selecciones de búsqueda y conversión
              </li>
              <li className='mb-1'>
                Cookies de seguridad necesarias para el funcionamiento del sitio
              </li>
            </ul>
            <p className='text-text-secondary mb-2'>
              Estas cookies no pueden ser desactivadas en nuestros sistemas.
            </p>
          </div>

          <div className='mb-6'>
            <h3 className='text-lg font-medium text-text-primary mb-2'>
              Cookies Analíticas (Estadísticas)
            </h3>
            <p className='text-text-secondary mb-2'>
              Estas cookies nos permiten contar las visitas y fuentes de tráfico
              para que podamos medir y mejorar el rendimiento de nuestro sitio.
              Nos ayudan a saber qué páginas son las más y menos populares, y
              ver cuántas personas visitan el sitio.
            </p>
            <p className='text-text-secondary mb-2'>
              Toda la información que recogen estas cookies es agregada y, por
              lo tanto, anónima. Si no permites estas cookies, no sabremos
              cuándo has visitado nuestro sitio.
            </p>
            <p className='text-text-secondary mb-2'>
              Ejemplos de cookies analíticas:
            </p>
            <ul className='list-disc pl-6 text-text-secondary mb-4'>
              <li className='mb-1'>Google Analytics (_ga, _gid)</li>
              <li className='mb-1'>
                Cookies para medir el tiempo de carga de las páginas
              </li>
              <li className='mb-1'>
                Cookies para realizar un seguimiento de las páginas más
                visitadas
              </li>
            </ul>
          </div>

          <div className='mb-6'>
            <h3 className='text-lg font-medium text-text-primary mb-2'>
              Cookies Funcionales
            </h3>
            <p className='text-text-secondary mb-2'>
              Estas cookies permiten que el sitio web proporcione una
              funcionalidad y personalización mejoradas. Pueden ser establecidas
              por nosotros o por proveedores externos cuyos servicios hemos
              añadido a nuestras páginas.
            </p>
            <p className='text-text-secondary mb-2'>
              Ejemplos de cookies funcionales:
            </p>
            <ul className='list-disc pl-6 text-text-secondary mb-4'>
              <li className='mb-1'>
                Cookies que recuerdan tus preferencias de visualización
              </li>
              <li className='mb-1'>
                Cookies que recuerdan los últimos códigos IAE o CNAE consultados
              </li>
              <li className='mb-1'>
                Cookies que mejoran la experiencia de uso del conversor
              </li>
            </ul>
          </div>

          <div className='mb-6'>
            <h3 className='text-lg font-medium text-text-primary mb-2'>
              Cookies de Marketing (No utilizamos actualmente)
            </h3>
            <p className='text-text-secondary mb-2'>
              Actualmente no utilizamos cookies de marketing o publicitarias en
              nuestro sitio web. Nos comprometemos a informarte si esta política
              cambia en el futuro.
            </p>
          </div>

          <h2 className='text-xl font-semibold text-text-primary mb-4 mt-6'>
            Control de tus cookies
          </h2>
          <p className='text-text-secondary mb-4'>
            Cuando visitas nuestro sitio por primera vez, te mostramos un banner
            de cookies que te permite aceptar o rechazar las cookies no
            esenciales.
          </p>
          <p className='text-text-secondary mb-4'>
            Puedes cambiar tus preferencias de cookies en cualquier momento
            utilizando las opciones que se muestran a continuación:
          </p>

          <h3 className='text-lg font-medium text-text-primary mb-2'>
            Configuración del navegador
          </h3>
          <p className='text-text-secondary mb-4'>
            La mayoría de los navegadores web permiten controlar la mayoría de
            las cookies a través de sus configuraciones. Para saber más sobre
            cómo gestionar las cookies en tu navegador, visita estos enlaces:
          </p>
          <ul className='list-disc pl-6 text-text-secondary mb-6'>
            <li className='mb-1'>
              <a
                href='https://support.google.com/chrome/answer/95647'
                target='_blank'
                rel='noopener noreferrer'
                className='text-primary hover:underline'
              >
                Google Chrome
              </a>
            </li>
            <li className='mb-1'>
              <a
                href='https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09'
                target='_blank'
                rel='noopener noreferrer'
                className='text-primary hover:underline'
              >
                Microsoft Edge
              </a>
            </li>
            <li className='mb-1'>
              <a
                href='https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias'
                target='_blank'
                rel='noopener noreferrer'
                className='text-primary hover:underline'
              >
                Mozilla Firefox
              </a>
            </li>
            <li className='mb-1'>
              <a
                href='https://support.apple.com/es-es/guide/safari/sfri11471/mac'
                target='_blank'
                rel='noopener noreferrer'
                className='text-primary hover:underline'
              >
                Safari
              </a>
            </li>
            <li className='mb-1'>
              <a
                href='https://help.opera.com/en/latest/web-preferences/#cookies'
                target='_blank'
                rel='noopener noreferrer'
                className='text-primary hover:underline'
              >
                Opera
              </a>
            </li>
          </ul>

          <h3 className='text-lg font-medium text-text-primary mb-2'>
            Tus opciones actuales
          </h3>
          <p className='text-text-secondary mb-4'>
            Puedes personalizar tu configuración de cookies utilizando los
            botones a continuación:
          </p>

          <div className='cookies-settings mb-6'>
            <button
              onClick={handleAcceptAll}
              className='bg-primary text-background px-6 py-2 rounded font-medium hover:bg-opacity-90 transition-colors mr-4'
            >
              Aceptar todas las cookies
            </button>
            <button
              onClick={handleEssentialOnly}
              className='bg-transparent border border-primary text-primary px-6 py-2 rounded font-medium hover:bg-primary hover:bg-opacity-10 transition-colors mr-4'
            >
              Solo aceptar cookies esenciales
            </button>
            <button
              onClick={handleToggleCustomPreferences}
              className='bg-transparent border border-primary text-primary px-6 py-2 rounded font-medium hover:bg-primary hover:bg-opacity-10 transition-colors'
            >
              Personalizar preferencias
            </button>
          </div>

          {showCustomPreferences && (
            <div
              id='custom-preferences'
              className='bg-background p-4 rounded-lg mb-6'
            >
              <div className='cookie-preference mb-4'>
                <div className='flex items-center'>
                  <input
                    type='checkbox'
                    id='essential-cookies'
                    checked
                    disabled
                    className='mr-2 h-5 w-5 text-primary'
                  />
                  <label
                    htmlFor='essential-cookies'
                    className='text-text-primary font-medium'
                  >
                    Cookies Esenciales (Necesarias)
                  </label>
                </div>
                <p className='text-text-secondary mt-1 ml-7'>
                  Estas cookies no pueden desactivarse ya que son necesarias
                  para el funcionamiento del sitio.
                </p>
              </div>

              <div className='cookie-preference mb-4'>
                <div className='flex items-center'>
                  <input
                    type='checkbox'
                    id='analytics-cookies'
                    name='analytics'
                    checked={cookiePreferences.analytics}
                    onChange={handleCheckboxChange}
                    className='mr-2 h-5 w-5 text-primary'
                  />
                  <label
                    htmlFor='analytics-cookies'
                    className='text-text-primary font-medium'
                  >
                    Cookies Analíticas
                  </label>
                </div>
                <p className='text-text-secondary mt-1 ml-7'>
                  Nos ayudan a entender cómo utilizas nuestro sitio para poder
                  mejorarlo.
                </p>
              </div>

              <div className='cookie-preference mb-4'>
                <div className='flex items-center'>
                  <input
                    type='checkbox'
                    id='functional-cookies'
                    name='functional'
                    checked={cookiePreferences.functional}
                    onChange={handleCheckboxChange}
                    className='mr-2 h-5 w-5 text-primary'
                  />
                  <label
                    htmlFor='functional-cookies'
                    className='text-text-primary font-medium'
                  >
                    Cookies Funcionales
                  </label>
                </div>
                <p className='text-text-secondary mt-1 ml-7'>
                  Proporcionan funcionalidades mejoradas y personalización.
                </p>
              </div>

              <button
                onClick={handleSavePreferences}
                className='bg-primary text-background px-6 py-2 rounded font-medium hover:bg-opacity-90 transition-colors'
              >
                Guardar preferencias
              </button>
            </div>
          )}

          <h2 className='text-xl font-semibold text-text-primary mb-4 mt-6'>
            Duración de las cookies
          </h2>
          <p className='text-text-secondary mb-2'>
            Las cookies que utilizamos tienen diferentes duraciones:
          </p>
          <ul className='list-disc pl-6 text-text-secondary mb-6'>
            <li className='mb-1'>
              Cookies de sesión: expiran cuando cierras el navegador
            </li>
            <li className='mb-1'>
              Cookies persistentes: permanecen en tu dispositivo durante un
              período específico (desde 30 días hasta 2 años, dependiendo de la
              finalidad)
            </li>
          </ul>

          <h2 className='text-xl font-semibold text-text-primary mb-4 mt-6'>
            Cambios en nuestra política de cookies
          </h2>
          <p className='text-text-secondary mb-4'>
            Cualquier cambio que podamos hacer en nuestra política de cookies en
            el futuro se publicará en esta página. Por favor, revisa esta
            política regularmente para estar informado de cualquier
            actualización.
          </p>

          <h2 className='text-xl font-semibold text-text-primary mb-4 mt-6'>
            Contacto
          </h2>
          <p className='text-text-secondary mb-2'>
            Si tienes alguna pregunta sobre nuestra política de cookies, por
            favor contáctanos en:
          </p>
          <ul className='list-disc pl-6 text-text-secondary mb-4'>
            <li className='mb-1'>
              <strong>Email:</strong> contacto@conversoriaecnae.es
            </li>
            <li className='mb-1'>
              <strong>Comunidad:</strong>{' '}
              <a
                href='https://www.reddit.com/r/ConversorIAE_CNAE/'
                target='_blank'
                rel='noopener noreferrer'
                className='text-primary hover:underline'
              >
                https://www.reddit.com/r/ConversorIAE_CNAE/
              </a>
            </li>
          </ul>
        </div>
      </main>
    </div>
  )
}

export default CookiesConfig
